import React from 'react'

const PostAd = () => {
  return (
    <div>PostAd</div>
  )
}

export default PostAd